import React from "react"
import { useEffect } from 'react'
import { useAuth } from "../contexts/AuthContext"
import { db } from '../firebase'
import { NavLink } from "react-router-dom";
import "../css/Home.css"
import ConnectionToast from "../components/ConnectionToast"
import '../css/Base.css'
import Player from '../images/player.png'

function Home() {

  const { currentUser } = useAuth()
  let isUserloggedIn = false;

  currentUser !== null ? isUserloggedIn = true : isUserloggedIn = false;

  useEffect(() => {

    if (isUserloggedIn) {
      //set username + other vars in FSTORE
      let docref1 = db.collection("Players").doc(`${currentUser.uid}`)
      docref1.get().then((player => {
        if (player.exists !== true) {
          docref1.set({
            username: currentUser.email.split("@")[0],
            totalBets: 0,
            betsLost: 0,
            betsWon: 0
          })
        }
      }))
    }

    // OFFLINE ONLINE TOAST
    let connectionLostToast = document.getElementById('connectionLost')
    connectionLostToast.setAttribute('autohide', false)

    window.addEventListener('offline', function () {
      connectionLostToast.style.display = "block"
    });

    window.addEventListener('online', function () {
      connectionLostToast.style.display = "none"
    });

  })

  return (
    <>
      <div className="divImagePlayer">
        <img className="imagePlayer" src={Player} width="500px" height="570px" alt="soccer-player" />
      </div>
      <ConnectionToast />
      <div className="row justify-content-md-center g-0">
        <div className="col-md-8 offset-md-1 mt-5">
          <h1 className="mt-5 mb-4 font-link-header">BET. GROW.
            <br /> ACHIEVE.
          </h1>
          <h5 className="mb-5 h5-home">
            Unlock your hidden potential with uSport. <br />
            uSport allows you to bet on upcomming matches. <br />
            It helps you develop your bet-accuracy. <br />
            You will be able to oversee all your previous bets. <br />
            Challenge yourself to the top and become a master of uSport <br />
            At the end, YOU will become the best. <br />
          </h5>
          <NavLink to="/dashboard" className="btn btn-info">
            GET STARTED
          </NavLink>
        </div>
      </div>
    </>
  )
}

export default Home;